<script>
import baseMixin from '@/mixins/baseMixin'
import idleMixin from '@/mixins/idleMixin'
import { mapActions, mapGetters } from 'vuex'
import CandidateZoom from '@/components/candidate/candidate-zoom.vue'
import MobileNavDrawer from '@/components/layout/mobile-nav-drawer.vue'
import TopFilterBar from '@/components/booking/bookingList/top-filter-bar.vue'
import BookingHeader from '@/components/booking/bookingList/booking-header.vue'
import BookingRow from '@/components/booking/bookingList/booking-row.vue'
import BookingListTab from '@/components/booking/bookingList/booking-list-tab.vue'
import NoBookingFound from '@/components/booking/bookingList/no-booking-found.vue'
import BookingRowSkeleton from '@/components/booking/bookingList/booking-row-skeleton.vue'
import ExportBookings from '@/components/booking/bookingList/export-bookings.vue'
import BookingSidePanel from '@/components/booking/bookingList/side-panel/booking-side-panel.vue'
import NoClientsSelected from '@/components/booking/bookingList/no-client-selected.vue'
import NoSearchResultFound from '@/components/booking/bookingList/no-search-result-found.vue'
import EmptyBookingsFound from '@/components/booking/bookingList/empty-bookings-found.vue'
import ApprovalContainer from '@/components/booking/bookingList/approval-container.vue'

export default {
  name: 'BookingListContainer',
  components: {
    TopFilterBar,
    BookingHeader,
    BookingRow,
    BookingListTab,
    NoBookingFound,
    BookingRowSkeleton,
    CandidateZoom,
    ExportBookings,
    BookingSidePanel,
    NoClientsSelected,
    NoSearchResultFound,
    EmptyBookingsFound,
    MobileNavDrawer,
    ApprovalContainer,
  },
  mixins: [baseMixin, idleMixin],
  data: () => {
    const today = new Date()
    const formatDate = (d) =>
      `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(
        d.getDate()
      ).padStart(2, '0')}`
    const addDays = (base, days) => {
      const d = new Date(base)
      d.setDate(d.getDate() + days)
      return d
    }
    return {
      sortKey: 'date',
      sortOrder: 'desc',
      approvalCount: 0,
      searchQuery: '',
      loading: false,
      pageNumber: 1,
      isFetchingMore: false,
      showCandidateModal: false,
      showExportModal: false,
      showSidePanel: false,
      showApprovalSidePanel: false,
      bookingDetails: null,
      exportMode: 'all',
      selectedCandidate: '',
      startDate: formatDate(addDays(today, -15)),
      endDate: formatDate(addDays(today, +15)),
      isBlockBookingFlag: false,
      filterStartTime: null,
      filterEndTime: null,
      isAnyFilterApplied: false,
      headers: [],
      selectedRows: [],
      showNotes: false,
      notesLocked: false,
      currentTabName: 'upcoming',
      activeTab: 1,
      clientList: [],
      selectedClientIds: [],
      locations: [],
      locationsId: [],
      educators: [],
      classifications: [],
      certifications: [],
      replacing: [],
      grades: [],
      selectedStatuses: [],
      selectedEducators: [],
      selectedClassifications: [],
      selectedCertifications: [],
      selectedGrades: [],
      selectedReplacing: [],
      activeBookingId: null,
    }
  },

  computed: {
    ...mapGetters({
      // locations: 'locations/bookingLocations',
      bookings: 'bookings/bookingList',
      totalPages: 'bookings/bookingListTotalPages',
      permissions: 'auth/permissions',
      approvalRequiredCount: 'bookings/approvalRequiredCount',
    }),

    isBlockView() {
      return this.$refs.topFilterBar?.showDayByDayBlock === false
    },

    isApprovalTab() {
      return this.$refs.bookingTabs?.activeTab === 'ApprovalRequired'
    },

    adjustedHeaders() {
      return this.headers.filter((h) => {
        if (
          this.activeTab !== 0 &&
          this.currentTabName !== 'ApprovalRequired'
        ) {
          if (['days'].includes(h.key)) return false
        }
        if (this.activeTab === 0) {
          // if (['status'].includes(h.key)) return false
        }
        if (
          this.currentTabName === 'upcoming' ||
          this.currentTabName === 'past' ||
          this.currentTabName === 'all'
        ) {
          if (['client'].includes(h.key)) return false
        }
        if (
          this.currentTabName === 'ApprovalRequired' ||
          this.currentTabName === 'cancelled'
        ) {
          if (['status'].includes(h.key)) return false
        }
        return true
      })
    },

    filteredBookings() {
      return this.bookings || []
    },

    allSelected() {
      return (
        this.selectedRows.length === this.filteredBookings.length &&
        this.filteredBookings.length > 0
      )
    },
    selectedBookingData() {
      return this.filteredBookings.filter((b) =>
        this.selectedRows.includes(b.id)
      )
    },
    exportFilters() {
      const to24HourDateTime = (dateStr, timeStr, fallback = '00:00') => {
        if (!dateStr) return null

        const [y, m, d] = dateStr.split('-').map(Number)
        const [hh, mm] = (timeStr ?? fallback).split(':').map(Number)

        // Pad numbers to 2 digits
        const pad = (n) => String(n).padStart(2, '0')

        return `${y}-${pad(m)}-${pad(d)} ${pad(hh)}:${pad(mm)}:00`
      }

      const hasAnyTime = !!(this.filterStartTime || this.filterEndTime)

      const sendStart = hasAnyTime
        ? to24HourDateTime(this.startDate, this.filterStartTime, '00:00')
        : this.startDate

      const sendEndBase = this.endDate ?? this.startDate
      const sendEnd = hasAnyTime
        ? to24HourDateTime(
            sendEndBase,
            this.filterEndTime ?? this.filterStartTime,
            '23:59'
          )
        : sendEndBase

      const locationsArray =
        this.selectedLocationsId && this.selectedLocationsId.length > 0
          ? this.selectedLocationsId
          : this.locationsId

      const dateFilterCondition =
        this.$refs.topFilterBar.$refs.dateFilter.condition

      return {
        tabType: this.currentTabName,
        isBlockBooking: this.isBlockBookingFlag,
        startDate: sendStart,
        endDate: sendEnd,
        dateFilterCondition: dateFilterCondition,
        clientids: this.selectedClientIds,
        status: this.selectedStatuses,
        educators: this.selectedEducators,
        classifications: this.selectedClassifications,
        certifications: this.selectedCertifications,
        grades: this.selectedGrades,
        replacings: this.selectedReplacing,
        locations: locationsArray,
        sortColumn: this.sortKey,
        isDescending: this.sortOrder === 'asc',
      }
    },
  },

  watch: {
    isBlockBookingFlag: {
      immediate: true,
      handler() {
        this.headers = this.getTranslatedHeaders()
      },
    },
  },

  created() {
    this.headers = this.getTranslatedHeaders()
  },

  async mounted() {
    await this.getClientsAndLocations(this.permissions)
    await this.getBookings()
    window.addEventListener('scroll', this.handlePageScroll)
  },

  beforeDestroy() {
    window.removeEventListener('scroll', this.handlePageScroll)
  },

  methods: {
    ...mapActions({
      loadBookingLocations: 'locations/loadBookingLocations',
      loadLocationBookingBlocks: 'locations/loadLocationBookingBlocks',
      setRecentLocation: 'bookings/setRecentLocation',
      getCertifications: 'locations/getCertifications',
      getReplacing: 'locations/getReplacing',
      getClassifications: 'client/getClassifications',
      getGrades: 'client/getGrades',
      getCandidates: 'candidate/getCandidates',
    }),

    async getBookings(isPagination = false) {
      if (!isPagination) {
        this.pageNumber = 1
        this.loading = true
      } else {
        this.isFetchingMore = true
      }

      const locationsArray =
        this.selectedLocationsId && this.selectedLocationsId.length > 0
          ? this.selectedLocationsId
          : this.locationsId

      const sTime = this.filterStartTime ? `${this.filterStartTime}:00` : ''
      const eTime = this.filterEndTime ? `${this.filterEndTime}:00` : ''

      const payload = {
        tabType: this.currentTabName,
        IsBlockBooking: this.isBlockBookingFlag,
        search: this.searchQuery || '',
        clientids: this.selectedClientIds,
        status: this.selectedStatuses,
        educators: this.selectedEducators,
        locations: locationsArray,
        classifications: this.selectedClassifications,
        certifications: this.selectedCertifications,
        grades: this.selectedGrades,
        replacings: this.selectedReplacing,
        pageSize: 20,
        pageNumber: this.pageNumber,
        sortColumn: this.sortKey,
        isDescending: this.sortOrder === 'asc',
        ...(this.currentTabName !== 'ApprovalRequired'
          ? {
              startDate: this.startDate,
              endDate: this.endDate,
              startTime: sTime,
              endTime: eTime,
            }
          : {}),
      }

      await this.$store.dispatch('bookings/getBookings', payload)

      if (!isPagination) {
        this.selectedRows = []
      }

      this.approvalCount = this.approvalRequiredCount

      this.loading = false
      this.isFetchingMore = false
    },

    async getClientsAndLocations(permissions) {
      const clients = []
      const locations = []

      for (const group of permissions) {
        for (const client of group.clients || []) {
          clients.push({
            clientId: client.clientId,
            clientName: client.clientName,
          })

          for (const location of client.locations || []) {
            locations.push({
              locationId: location.locationId,
              locationName: location.locationName,
            })
          }
        }
      }

      this.clientList = clients
      this.locations = locations
      this.selectedClientIds = clients.map((c) => c.clientId)
      this.locationsId = locations.map((c) => c.locationId)

      this.getFilterData(this.selectedClientIds, this.locationsId)
    },

    async getFilterData(clientIds, locationIds) {
      if (!clientIds?.length || !locationIds?.length) return

      const [candidates, classifications, certifications, replacing, grades] =
        await Promise.all([
          this.getCandidates(clientIds),
          this.getClassifications(clientIds),
          this.getCertifications(locationIds),
          this.getReplacing(locationIds),
          this.getGrades(clientIds),
        ])

      this.educators = candidates.data || []
      this.classifications = classifications.data || []
      this.certifications = certifications.data || []
      this.replacing = replacing.data || []
      this.grades = grades.data || []
    },

    sortData(key) {
      if (this.sortKey === key) {
        this.sortOrder = this.sortOrder === 'asc' ? 'desc' : 'asc'
      } else {
        this.sortKey = key
        this.sortOrder = 'desc'
      }

      this.getBookings()
    },

    toggleRowSelection(id) {
      const idx = this.selectedRows.indexOf(id)
      if (idx > -1) {
        this.selectedRows.splice(idx, 1)
      } else {
        this.selectedRows.push(id)
      }
    },

    toggleSelectAll() {
      this.selectedRows = this.allSelected
        ? []
        : this.filteredBookings.map((b) => b.id)
    },
    handleTableMouseEnter() {
      if (!this.notesLocked) this.showNotes = true
    },
    handleTableMouseLeave() {
      if (!this.notesLocked) this.showNotes = false
    },
    updateAndLockShowNotes(val) {
      this.showNotes = val
      this.notesLocked = val
    },
    handleTabChange(tabName) {
      this.currentTabName = tabName
      if (
        this.currentTabName === 'ApprovalRequired' ||
        this.currentTabName === 'cancelled'
      ) {
        this.$refs.topFilterBar.toggleDayByDayBlock(0)
      } else {
        this.getBookings()
      }
    },
    handleSearch(searchText) {
      this.searchQuery = searchText
      this.getBookings()
    },
    handleResetSearch() {
      this.searchQuery = ''
      if (
        this.$refs.topFilterBar &&
        this.$refs.topFilterBar.$refs.searchBookings.clearSearchBarAndClose
      ) {
        this.$refs.topFilterBar.$refs.searchBookings.clearSearchBarAndClose()
      }
      this.getBookings()
    },
    handleResetFilters() {
      this.$refs.topFilterBar.$refs.filterBookings.clearFilter(0, false)
    },
    handlePageScroll() {
      const scrollTop = window.scrollY || document.documentElement.scrollTop
      const windowHeight = window.innerHeight
      const documentHeight = document.documentElement.offsetHeight

      const nearBottom = scrollTop + windowHeight >= documentHeight - 100

      if (
        nearBottom &&
        !this.loading &&
        !this.isFetchingMore &&
        this.pageNumber < this.totalPages
      ) {
        this.pageNumber++
        this.getBookings(true)
      }
    },
    showCandidateDialog(candidateId) {
      this.selectedCandidate = candidateId
      this.showCandidateModal = true
    },
    closeCandidateDialog() {
      this.selectedCandidate = null
      this.showCandidateModal = false
    },
    handleDateFilter({ startDate, endDate }) {
      this.startDate = startDate
      this.endDate = endDate
      this.getBookings()
    },
    openExportAll() {
      this.exportMode = 'all'
      this.showExportModal = true
    },
    openExportSelected() {
      this.exportMode = 'selected'
      this.showExportModal = true
    },
    handleClientFilter(newIds) {
      this.selectedClientIds = newIds
      this.getBookings()
    },
    showAllClients() {
      this.selectedClientIds = this.clientList.map((c) => c.clientId)
      this.getBookings()
    },
    openSidePanel(bookingDetails) {
      this.bookingDetails = bookingDetails
      this.showSidePanel = true
    },
    getTranslatedHeaders() {
      return [
        {
          key: 'date',
          label: this.$t('bookingList.headerName.date'),
          width: this.isBlockBookingFlag ? '210px' : '150px',
        },
        {
          key: 'days',
          label: this.$t('bookingList.headerName.days'),
          width: '150px',
        },
        {
          key: 'educator',
          label: this.$t('bookingList.headerName.educator'),
          width: this.isBlockBookingFlag ? '150px' : '250px',
        },
        {
          key: 'time',
          label: this.$t('bookingList.headerName.time'),
          width: '180px',
        },
        {
          key: 'status',
          label: this.$t('bookingList.headerName.status'),
          width: '125px',
        },
        {
          key: 'classification',
          label: this.$t('bookingList.headerName.classification'),
          width: '150px',
        },
        {
          key: 'room',
          label: this.$t('bookingList.headerName.room'),
          width: '100px',
        },
        {
          key: 'replacing',
          label: this.$t('bookingList.headerName.replacing'),
          width: '150px',
        },
        {
          key: 'grade',
          label: this.$t('bookingList.headerName.grade'),
          width: 'auto',
        },
        {
          key: 'certifications',
          label: this.$t('bookingList.headerName.certification'),
          width: 'auto',
        },
        {
          key: 'client',
          label: this.$t('bookingList.headerName.client'),
          width: 'auto',
        },
      ]
    },
    handleFilterChange(filters) {
      this.selectedStatuses = filters.status
      this.selectedEducators = filters.educators
      this.selectedLocationsId = filters.locations
      this.selectedClassifications = filters.classifications
      this.selectedCertifications = filters.certifications
      this.selectedGrades = filters.grades
      this.selectedReplacing = filters.replacing
      this.filterStartTime = filters.startTime || null
      this.filterEndTime = filters.endTime || null
      this.isAnyFilterApplied = filters.isAnyFilterActive || false

      this.getBookings()
    },
    onViewModeChange(e) {
      this.activeTab = e
      this.isBlockBookingFlag = e === 0
      this.getBookings()
    },
    handleDeclineAndApprovalOfBooking(bookingId) {
      this.activeBookingId = bookingId
      this.showApprovalSidePanel = true
    },
    hideApprovalSidePanel() {
      this.activeBookingId = null
      this.showApprovalSidePanel = false
    },
  },
}
</script>

<template>
  <div>
    <div
      class="d-flex px-3"
      style="align-items: flex-start; justify-content: space-between"
    >
      <div
        class="d-flex pt-2"
        style="align-items: center; justify-content: center"
      >
        <MobileNavDrawer />
        <v-icon class="me-3" :class="[isMobileViewPort ? 'ml-4' : '']" size="20"
          >mdi-calendar-month</v-icon
        >
        <h5 class="page-title">{{ $t('bookingList.pageTitle') }}</h5>
      </div>
      <div>
        <TopFilterBar
          ref="topFilterBar"
          v-model="searchQuery"
          :client-list="clientList"
          :selected-client-ids="selectedClientIds"
          :clients-count="filteredBookings.length"
          :selected-count="selectedRows.length"
          :current-tab-name="currentTabName"
          :locations="locations"
          :educators="educators"
          :classifications="classifications"
          :certifications="certifications"
          :grades="grades"
          :replacing="replacing"
          @filter-change="handleFilterChange"
          @active-tab="onViewModeChange"
          @search="handleSearch"
          @date-filter="handleDateFilter"
          @export="openExportAll"
          @export-selected="openExportSelected"
          @update:selectedClientIds="handleClientFilter"
        />
      </div>
    </div>

    <div id="app" class="w-full">
      <div class="table-scroll-wrapper">
        <BookingListTab
          ref="bookingTabs"
          :approval-count="approvalCount"
          @set-tab="handleTabChange"
        />
        <div
          class="table-container"
          @mouseenter="handleTableMouseEnter"
          @mouseleave="handleTableMouseLeave"
        >
          <table>
            <BookingHeader
              :headers="adjustedHeaders"
              :sort-key="sortKey"
              :sort-order="sortOrder"
              :all-selected="allSelected"
              :show-notes="showNotes"
              :current-tab-name="currentTabName"
              :active-tab="activeTab"
              @sort="sortData"
              @toggle-all="toggleSelectAll"
            />

            <!-- when there are results -->
            <tbody v-if="(selectedClientIds || []).length === 0" class="h-full">
              <tr style="height: 100%">
                <td
                  :colspan="headers.length + 1"
                  style="height: 100%; padding: 0"
                >
                  <div class="no-booking-wrapper">
                    <NoClientsSelected @reset="showAllClients" />
                  </div>
                </td>
              </tr>
            </tbody>

            <tbody v-else-if="loading && pageNumber === 1">
              <BookingRowSkeleton
                v-for="i in 20"
                :key="'skeleton-' + i"
                :colspan="adjustedHeaders.length + 3"
              />
            </tbody>

            <tbody v-else-if="filteredBookings.length">
              <BookingRow
                v-for="booking in filteredBookings"
                :key="`booking-row-${booking.id}`"
                :booking="booking"
                :selected="selectedRows.includes(booking.id)"
                :show-notes="showNotes"
                :current-tab-name="currentTabName"
                :active-tab="activeTab"
                @toggle-select="toggleRowSelection(booking.id)"
                @viewCandidate="showCandidateDialog"
                @sidePanel="openSidePanel"
                @update-show-notes="updateAndLockShowNotes"
                @activeBookingId="handleDeclineAndApprovalOfBooking"
              />
              <!-- Skeleton only for fetching next page -->
              <template v-if="isFetchingMore">
                <BookingRowSkeleton
                  v-for="i in 5"
                  :key="'loading-more-' + i"
                  :colspan="adjustedHeaders.length + 3"
                />
              </template>
            </tbody>

            <!-- when no results -->
            <tbody v-else class="h-full">
              <tr style="height: 100%">
                <td
                  :colspan="headers.length + 1"
                  style="height: 100%; padding: 0"
                >
                  <div class="no-booking-wrapper">
                    <NoSearchResultFound
                      v-if="searchQuery && searchQuery.length > 0"
                      @resetSearch="handleResetSearch"
                    />
                    <NoBookingFound
                      v-else-if="
                        isAnyFilterApplied &&
                        !searchQuery &&
                        (selectedClientIds || []).length > 0
                      "
                      @resetFilters="handleResetFilters"
                    />
                    <EmptyBookingsFound
                      v-else
                      :current-tab-name="currentTabName"
                    />
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <v-dialog
      v-if="showCandidateModal"
      v-model="showCandidateModal"
      width="720px"
      content-class="rounded-xl"
    >
      <CandidateZoom
        :id="selectedCandidate"
        @closeModal="closeCandidateDialog"
      />
    </v-dialog>

    <v-dialog
      v-if="showExportModal"
      v-model="showExportModal"
      width="600px"
      height="auto"
      content-class="rounded-xl"
    >
      <ExportBookings
        :export-mode="exportMode"
        :selected-count="selectedRows.length"
        :selected-bookings="selectedBookingData"
        :filters="exportFilters"
        @close="showExportModal = false"
        @unselected-rows="selectedRows = []"
      />
    </v-dialog>

    <BookingSidePanel v-model="showSidePanel" :booking="bookingDetails" />

    <ApprovalContainer
      v-model="showApprovalSidePanel"
      :active-booking-id="activeBookingId"
      @update:activeBookingId="activeBookingId = $event"
      @reloadBookingList="getBookings"
    />
  </div>
</template>

<style lang="scss" scoped>
@import '@/styles/_colors.scss';
@import '@/styles/bookingList/booking-list.scss';
</style>
